var exports = {
  "kL": "x234b8571--855623--container",
  "ed": "x234b8571--855623--disclaimer",
  "Ki": "x234b8571--855623--video",
};

module.exports = exports;
